import { z } from 'zod';

export const EXCHANGE_RATE_SORTS = ['pair', '-pair', 'fetchedAt', '-fetchedAt'] as const;

/**
 * URL search params of the exchange rates route. The list is bounded, so search, filters and
 * sort run on the client; a malformed value falls back to "not set" instead of failing the route.
 */
export const exchangeRateListSearchSchema = z.object({
  q: z.string().optional().catch(undefined),
  sort: z.enum(EXCHANGE_RATE_SORTS).optional().catch(undefined),
  baseCurrency: z.string().optional().catch(undefined),
  source: z.string().optional().catch(undefined),
});

export type ExchangeRateListSearch = z.infer<typeof exchangeRateListSearchSchema>;
